import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acceuil',
  templateUrl: './acceuil.component.html',
  styleUrls: ['./acceuil.component.scss']
})
export class AcceuilComponent implements OnInit {

  scrollBanner : string
  imageObject: Array<object> = [{
    image: 'assets/photosBrigitte/image0.jpeg',
    thumbImage: 'assets/photosBrigitte/imagePortait.jpg',
    alt: 'alt of image',
  },{
    image: 'assets/photosBrigitte/logoPortrait.png',
    thumbImage: 'assets/photosBrigitte/logoPortrait.png',
    alt: 'alt of image',
  }
];

  constructor() { }

  ngOnInit(): void {
    this.scrollBanner = "0";
  }

  


  @HostListener('window:scroll') onScroll(e: Event): void {
    this.scrollBanner = +window.scrollY/3+"%";
    
 }

}
